<template>
  <div style="height: 0px; overflow: hidden; transform: translateY(-20px)">
    <input
      tabindex="-1"
      :value="email ? validate : validated ? 'validated' : 'not'"
      required
      style="width: 100%; margin-top: -100%; height: 20px"
      :pattern="email ? undefined : 'validated'"
      :title="$props.title"
      :type="email ? 'email' : undefined"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  validate?: number | string | string[] | number[] | Record<string | number, any> | null | boolean;
  title?: string;
  email?: boolean;
  regex?: RegExp;
}>();

const validated = computed(() => {
  const validate = props.validate || "";
  if (props.regex && typeof validate === "string") return props.regex?.test(validate);
  if ((typeof validate === "string" || Array.isArray(validate)) && !validate.length) return false;
  if (typeof validate === "object") return true;
  if (!validate) return false;

  return true;
});
</script>

<style scoped lang="scss">
//
</style>
